
const routerArr = [

    // {
    //     path: '/',
    //     redirect: '/sdjz_homepage',
    //     // name: 'sdjz_homepage',
    //     // component: () => import(/* webpackChunkName: 'education' */ './page/sdjzHomepage.vue'),
    // },
    {
        path: '/sdjz_homepage',
        name: 'sdjz_homepage',
        meta: { title:'山东家政培训首页' , login:false },
        component: () => import(/* webpackChunkName: 'education' */ './page/sdjzHomepage.vue'),
    },
    {
        path: '/sdjz_yanglao2',
        name: 'sdjz_yanglao2',
        meta: { title:'养老详情页' , login:false },
        component: () => import(/* webpackChunkName: 'education' */ './page/sdjz_yanglao2.vue'),
    },
    {
        path: '/shandongCertificate',
        name: 'shandongCertificate',
        meta: { title:'证书查询' , login:false },
        component: () => import(/* webpackChunkName: 'education' */ './page/certificate.vue'),
    },

]
export default routerArr
